import { render, staticRenderFns } from "./DiscussionGroup.vue?vue&type=template&id=8a58924a&scoped=true&"
import script from "./DiscussionGroup.vue?vue&type=script&lang=js&"
export * from "./DiscussionGroup.vue?vue&type=script&lang=js&"
import style0 from "./DiscussionGroup.vue?vue&type=style&index=0&id=8a58924a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a58924a",
  null
  
)

export default component.exports